import {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
  fetchBaseQuery,
} from "@reduxjs/toolkit/query/react";

import { localStorageService } from "./localstorage-service";
import { refreshSession } from "./refresh-session";

const baseUrl = import.meta.env.VITE_API_BASE_URL;

const rawBaseQuery = fetchBaseQuery({
  baseUrl,
  prepareHeaders: async (headers) => {
    const token = await localStorageService.getToken();
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

const getRequestUrl = (args: string | FetchArgs): string =>
  typeof args === "string" ? args : args.url;

const isRefreshRequest = (args: string | FetchArgs): boolean => {
  const url = getRequestUrl(args);
  return url.includes("/auth/refresh") || url.endsWith("/refresh");
};

export const baseApiQuery: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  let result = await rawBaseQuery(args, api, extraOptions);

  if (result.error?.status !== 401 || isRefreshRequest(args)) {
    return result;
  }

  const refreshed = await refreshSession();
  if (refreshed !== "ok") {
    return result;
  }

  return rawBaseQuery(args, api, extraOptions);
};
